import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";

const AccordionList = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const accordionItems = [
    [
      {
        question: "What is a Job Board Consultant?",
        answer:
          "A Job Board Consultant helps businesses and organizations optimize their job boards to attract, engage, and hire top talent. This includes improving job board design.",
      },
      {
        question: "What services do you offer?",
        answer:
          "We offer a range of services including job board design, SEO optimization, user experience audits, and content strategy.",
      },
      {
        question: "Who are your clients?",
        answer:
          "Our clients range from small startups to large enterprises across various industries looking to improve their job board performance.",
      },
      {
        question: "How do you ensure client success?",
        answer:
          "We ensure client success through data-driven strategies, regular communication, and a focus on measurable results and continuous improvement.",
      },
      {
        question: "How do you ensure client success?",
        answer:
          "We ensure client success through data-driven strategies, regular communication, and a focus on measurable results and continuous improvement.",
      },
      {
        question: "How do you ensure client success?",
        answer:
          "We ensure client success through data-driven strategies, regular communication, and a focus on measurable results and continuous improvement.",
      },
    ],
    [
      {
        question: "What is a Job Board Consultant?",
        answer:
          "A Job Board Consultant helps businesses and organizations optimize their job boards to attract, engage, and hire top talent. This includes improving job board design.",
      },
      {
        question: "How do you ensure client success?",
        answer:
          "We ensure client success through data-driven strategies, regular communication, and a focus on measurable results and continuous improvement.",
      },
      {
        question: "What services do you offer?",
        answer:
          "We offer a range of services including job board design, SEO optimization, user experience audits, and content strategy.",
      },
      {
        question: "What is a Job Board Consultant?",
        answer:
          "A Job Board Consultant helps businesses and organizations optimize their job boards to attract, engage, and hire top talent. This includes improving job board design.",
      },
      {
        question: "What is a Job Board Consultant?",
        answer:
          "A Job Board Consultant helps businesses and organizations optimize their job boards to attract, engage, and hire top talent. This includes improving job board design.",
      },
      {
        question: "What is a Job Board Consultant?",
        answer:
          "A Job Board Consultant helps businesses and organizations optimize their job boards to attract, engage, and hire top talent. This includes improving job board design.",
      },
    ],
  ];

  const toggleAccordion = (colIndex, itemIndex) => {
    const key = `${colIndex}-${itemIndex}`;
    setOpenIndex((prev) => (prev === key ? null : key));
  };

  return (
    <div className="bg-blue-50 py-12">
      <div className="max-w-8xl mx-auto px-10">
        <h1
          className="text-[#1A5298] text-2xl font-semibold text-center"
          data-aos="fade-up"
          data-aos-delay="900"
        >
          Frequently Asked Questions
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-x-20 mt-10">
          {accordionItems.map((columnItems, colIndex) => (
            <div key={colIndex}>
              {columnItems.map((item, itemIndex) => (
                <div
                  data-aos="fade-up"
                  data-aos-delay="600"
                  key={itemIndex}
                  className={`border-b border-blue-200 ${
                    itemIndex === 0 ? "border-t" : ""
                  }`}
                >
                  <div
                    className="flex justify-between items-center py-4 cursor-pointer"
                    onClick={() => toggleAccordion(colIndex, itemIndex)}
                  >
                    <h3
                      className={`text-lg font-semibold ${
                        openIndex === `${colIndex}-${itemIndex}`
                          ? "text-blue-700"
                          : "text-gray-800"
                      }`}
                    >
                      {item.question}
                    </h3>
                    {openIndex === `${colIndex}-${itemIndex}` ? (
                      <FaMinus className="text-blue-700" />
                    ) : (
                      <FaPlus className="text-gray-600" />
                    )}
                  </div>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openIndex === `${colIndex}-${itemIndex}`
                        ? "max-h-[200px] opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    <div className="pb-4 text-gray-700">{item.answer}</div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccordionList;
